import { refsService as refs } from '@/app/shared/refs.service';
import { i18n } from '@/plugins';
import { cnpj, cpf } from 'cpf-cnpj-validator';

export class Rules {
  public static required = (v: string) => !!v || i18n.t('rules.required');

  public static requiredIf = (conditional: boolean) => {
    return (v: string) =>
      !conditional ? true : !!v || i18n.t('rules.required');
  };

  public static hipercardBrand = (v: string) => {
    const matching = [];
    matching.push(
      { Key: '606282' },
      { Key: '637095' },
      { Key: '637568' },
      { Key: '637599' },
      { Key: '637609' },
      { Key: '637612' }
    );

    for (let i = 0; i < matching.length; i++) {
      if (v && v.startsWith(matching[i].Key)) return true;
    }
    return false;
  };

  public static minLength = (v: string) =>
    (v && v.length >= 8) || i18n.t('rules.min_length');

  public static email = (v: string) =>
    new RegExp(/^[\w.-]+(\+[\w-]*)?@([\w-]+\.)+[\w-]+$/).test(v) ||
    i18n.t('rules.email');

  public static emailIf = (conditional: boolean) => {
    return (v: string) =>
      !conditional
        ? true
        : new RegExp(/^[\w.-]+(\+[\w-]*)?@([\w-]+\.)+[\w-]+$/).test(v) ||
          i18n.t('rules.email');
  };

  public static monthYear = (v: string) =>
    new RegExp(/(0[0-9]|1[0-2])\/\d{4}/).test(v) || i18n.t('rules.date');

  public static cpf = (v: string) => cpf.isValid(v) || i18n.t('rules.cpf');

  public static cnpj = (v: string) => cnpj.isValid(v) || i18n.t('rules.cnpj');

  public static cardExpiration = (v: string) =>
    refs._.isEmpty(v)
      ? true
      : (v?.length == 7 && refs.moment(v, 'MM/YYYY').isAfter()) ||
        i18n.t('rules.card_expiration');

  public static emailSplit = (v: string) => {
    let emailValidReturn = true;
    if (v == '') return true;

    if (v.indexOf(',') > 0) return false;
    if (v.indexOf(' ') > 0) return false;

    if (
      Array.from(v).filter((x) => x == ';').length -
        Array.from(v).filter((x) => x == '@').length !=
      -1
    )
      return false;
    const emailArray = v.split(';');
    emailArray.forEach((x) => {
      const validEmail = new RegExp(
        /^[\w.-]+(\+[\w-]*)?@([\w-]+\.)+[\w-]+$/
      ).test(x);
      if (!validEmail) {
        emailValidReturn = false;
      }
    });
    return emailValidReturn;
  };
  public static invalidCardExpiration = (v: string) => {
    if (v != null) {
      if (v.length == 7) {
        if (
          parseInt(v.split('/')[0]) > 12 ||
          (parseInt(v.split('/')[0]) < new Date().getMonth() + 1 &&
            parseInt(v.split('/')[1]) == new Date().getFullYear()) ||
          parseInt(v.split('/')[1]) < new Date().getFullYear()
        ) {
          i18n.t('rules.card_expiration');
          return false;
        } else return true;
      }
    }
    return false;
  };

  public static invalidBirthDate = (v: string) => {
    if (v != null) {
      if (v.toString().length == 10) {
        const day = v.split('/')[0];
        const month = v.split('/')[1];
        const year = v.split('/')[2];
        const limitDate = new Date();
        const date = new Date();
        date.setDate(parseInt(day));
        date.setMonth(parseInt(month) - 1);
        date.setFullYear(parseInt(year));
        limitDate.setFullYear(new Date().getFullYear() - 18);
        if (date.getTime() > limitDate.getTime()) {
          return i18n.t('rules.birthdate');
        } else return true;
      }
    }
    return true;
  };

  public static invalidCardHolder = (v: string) => {
    const hasNumber = /\d/;
    return hasNumber.test(v) == false ? true : false;
  };

  public static finishDate = (v: string) =>
    refs._.isEmpty(v)
      ? true
      : (v?.length == 10 && refs.moment(v, 'DD/MM/YYYY').isSameOrAfter()) ||
        i18n.t('rules.card_expiration');

  public static branchDigit = (v: string) => {
    const hasNumber = /[xX|0-9]/;
    return hasNumber.test(v);
  };
}
